/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/api-integrations.js":
/*!*******************************************!*\
  !*** ./js/components/api-integrations.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UPLOAD_CONFIG: () => (/* binding */ UPLOAD_CONFIG),
/* harmony export */   completeUpload: () => (/* binding */ completeUpload),
/* harmony export */   createUpload: () => (/* binding */ createUpload),
/* harmony export */   signParts: () => (/* binding */ signParts)
/* harmony export */ });
/* unused harmony export API_BASE */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");



// Config constants
var API_BASE = "https://twkeiu3ujd.execute-api.eu-north-1.amazonaws.com/dev";
var UPLOAD_CONFIG = {
  PART_SIZE: 5 * 1024 * 1024,
  // 5MB per part
  CONCURRENCY: 6,
  // 6 concurrent uploads per file
  RETRY_COUNT: 3,
  // retry up to 3 times on network errors
  BACKOFF_DELAY: attempt => 500 * Math.pow(2, attempt) // exponential backoff
};
var apiClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json"
  }
});

// Create multipart upload
var createUpload = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (filename, contentType, signal) {
    var newVariableDate = new Date();
    var formattedFilename = "".concat(newVariableDate.toISOString().split('T')[0], "/").concat(newVariableDate.getTime(), "/").concat(filename);
    try {
      console.log("Creating upload for file: ".concat(formattedFilename, " (").concat(contentType, ")"), {
        hasSignal: !!signal,
        signalAborted: signal === null || signal === void 0 ? void 0 : signal.aborted,
        API_BASE
      });
      var response = yield apiClient.post('/create-upload', {
        filename: formattedFilename,
        contentType
      }, {
        signal
      });
      return response.data; // { key, uploadId }
    } catch (error) {
      var _error$response, _error$response2, _error$response3;
      if (error.name === "AbortError" || error.name === "CanceledError") {
        console.warn('createUpload aborted');
        throw new DOMException("Upload aborted", "AbortError");
      }

      // Check for CORS errors
      if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
        var corsError = new Error('CORS Error: The API server is not configured to handle cross-origin requests. ' + 'The server needs to respond to OPTIONS preflight requests with proper CORS headers. ' + 'Please contact the API administrator to enable CORS for this endpoint.');
        corsError.name = 'CORSError';
        corsError.originalError = error;
        console.error("createUpload CORS error:", corsError);
        throw corsError;
      }
      var errorMessage = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 || (_error$response = _error$response.errorDetails) === null || _error$response === void 0 ? void 0 : _error$response.errorMessage) || (error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 ? void 0 : _error$response2.message) || (error === null || error === void 0 ? void 0 : error.message) || "Failed to create upload: ".concat((error === null || error === void 0 || (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) || 'Unknown error');
      console.error("createUpload error:", error, {
        name: (error === null || error === void 0 ? void 0 : error.name) || "Unknown",
        message: errorMessage,
        signalAborted: signal === null || signal === void 0 ? void 0 : signal.aborted
      });
      throw new Error(errorMessage);
    }
  });
  return function createUpload(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// Get presigned URLs for parts
var signParts = /*#__PURE__*/function () {
  var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (key, uploadId, partNumbers, contentType, signal) {
    try {
      var response = yield apiClient.post('/sign-parts', {
        key,
        uploadId,
        partNumbers,
        contentType
      }, {
        signal
      });
      return response.data; // { urls: [{ partNumber, url }] }
    } catch (error) {
      var _error$response4, _error$response5, _error$response6;
      if (error.name === "AbortError" || error.name === "CanceledError") {
        throw new DOMException("Upload aborted", "AbortError");
      }
      var errorMessage = (error === null || error === void 0 || (_error$response4 = error.response) === null || _error$response4 === void 0 || (_error$response4 = _error$response4.data) === null || _error$response4 === void 0 || (_error$response4 = _error$response4.errorDetails) === null || _error$response4 === void 0 ? void 0 : _error$response4.errorMessage) || (error === null || error === void 0 || (_error$response5 = error.response) === null || _error$response5 === void 0 || (_error$response5 = _error$response5.data) === null || _error$response5 === void 0 ? void 0 : _error$response5.message) || (error === null || error === void 0 ? void 0 : error.message) || "Failed to sign parts: ".concat((error === null || error === void 0 || (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.status) || 'Unknown error');
      throw new Error(errorMessage);
    }
  });
  return function signParts(_x4, _x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

// Complete multipart upload
var completeUpload = /*#__PURE__*/function () {
  var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (key, uploadId, parts, signal) {
    try {
      var response = yield apiClient.post('/complete-upload', {
        key,
        uploadId,
        parts
      }, {
        signal
      });
      return response.data; // { location }
    } catch (error) {
      var _error$response7, _error$response8, _error$response9;
      if (error.name === "AbortError" || error.name === "CanceledError") {
        throw new DOMException("Upload aborted", "AbortError");
      }
      var errorMessage = (error === null || error === void 0 || (_error$response7 = error.response) === null || _error$response7 === void 0 || (_error$response7 = _error$response7.data) === null || _error$response7 === void 0 || (_error$response7 = _error$response7.errorDetails) === null || _error$response7 === void 0 ? void 0 : _error$response7.errorMessage) || (error === null || error === void 0 || (_error$response8 = error.response) === null || _error$response8 === void 0 || (_error$response8 = _error$response8.data) === null || _error$response8 === void 0 ? void 0 : _error$response8.message) || (error === null || error === void 0 ? void 0 : error.message) || "Failed to complete upload: ".concat((error === null || error === void 0 || (_error$response9 = error.response) === null || _error$response9 === void 0 ? void 0 : _error$response9.status) || 'Unknown error');
      throw new Error(errorMessage);
    }
  });
  return function completeUpload(_x9, _x0, _x1, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./js/components/chunk-file.js":
/*!*************************************!*\
  !*** ./js/components/chunk-file.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getFileParts: () => (/* binding */ getFileParts)
/* harmony export */ });
/* harmony import */ var _api_integrations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./api-integrations */ "./js/components/api-integrations.js");

function getFileParts(file) {
  var {
    PART_SIZE
  } = _api_integrations__WEBPACK_IMPORTED_MODULE_0__.UPLOAD_CONFIG;
  var parts = [];
  var start = 0;
  var partNumber = 1;
  while (start < file.size) {
    var end = Math.min(start + PART_SIZE, file.size);
    parts.push({
      partNumber,
      blob: file.slice(start, end)
    });
    start = end;
    partNumber++;
  }
  return parts;
}

/***/ }),

/***/ "./js/components/design-components/upload-design-selector.js":
/*!*******************************************************************!*\
  !*** ./js/components/design-components/upload-design-selector.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UploadDesign: () => (/* binding */ UploadDesign)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _use_large_upload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../use-large-upload */ "./js/components/use-large-upload.js");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var UploadDesign = _ref => {
  var {
    shopifyData,
    isUploadContainerOpen,
    setIsUploadContainerOpen,
    onFilesChange
  } = _ref;
  var fileInputRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var [filesState, setFilesState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]); // { id, file, name, size, status, progress, uploadResult, abortController }
  var [isDragging, setIsDragging] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
  var statusStringRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)('');
  var uploadSingleRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var allowNavigationRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);

  // useLargeUpload hook assumed to expose uploadFile(file, onProgress, signal)
  var {
    uploadFile
  } = (0,_use_large_upload__WEBPACK_IMPORTED_MODULE_3__.useLargeUpload)();
  var MAX_FILES = 5;
  var MAX_FILE_SIZE = 1 * 1024 * 1024 * 1024;

  // Auto-clear error after 5 seconds
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (error) {
      var timer = setTimeout(() => setError(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    return () => {
      filesState.forEach(f => {
        var _f$abortController;
        return ((_f$abortController = f.abortController) === null || _f$abortController === void 0 ? void 0 : _f$abortController.abort) && f.abortController.abort();
      });
    };
  }, []);

  // Notify parent when files are added or removed
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (onFilesChange) {
      onFilesChange(filesState.length > 0);
    }
  }, [filesState.length, onFilesChange]);
  var handleCardClick = () => setIsUploadContainerOpen(!isUploadContainerOpen);
  var handleFileInputClick = () => {
    var _fileInputRef$current;
    return (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
  };
  
  var validateFile = file => {
    if (file.size > MAX_FILE_SIZE) {
      setError("File \"".concat(file.name, "\" exceeds the maximum size of 1 GB."));
      return false;
    }
    return true;
  };


         
  //JK Uploading Design//
  
  window.onload = function() {
    //alert(2);
    handleCardClick();
    handleFileInputClick(); 
  };

  //JK//





  // Add files and create abort controllers
  var addFiles = filesArray => {
    setError(null);
    if (filesState.length + filesArray.length > MAX_FILES) {
      setError("You can only upload up to ".concat(MAX_FILES, " files."));
      return;
    }
    var validFiles = filesArray.filter(validateFile);
    if (validFiles.length === 0) return;
    var timestamp = Date.now();
    var newEntries = validFiles.map((file, idx) => {
      return {
        id: "".concat(timestamp, "-").concat(idx, "-").concat(Math.random().toString(36).slice(2, 8)),
        file,
        name: file.name,
        size: file.size,
        status: "queued",
        // queued | uploading | uploaded | failed | cancelled
        progress: 0,
        uploadResult: null,
        error: null,
        abortController: new AbortController()
      };
    });
    setFilesState(prev => {
      var updated = [...prev, ...newEntries];
      return updated;
    });

    // Dispatch custom event for compatibility
    validFiles.forEach(file => {
      if (typeof window !== "undefined") {
        var event = new CustomEvent("design-file-uploaded", {
          detail: {
            file
          }
        });
        window.dispatchEvent(event);
      }
    });
  };
  var handleFileChange = e => {
    var files = Array.from(e.target.files || []);
    addFiles(files);
    e.target.value = "";
  };
  var handleRemoveFile = fileId => {
    // If uploading, abort first
    setFilesState(prev => {
      var found = prev.find(p => p.id === fileId);
      if (found) {
        // Abort upload if in progress
        if (found.abortController) {
          try {
            found.abortController.abort();
          } catch (e) {}
        }

        // Remove location from storage if file was uploaded
        if (found.uploadResult && found.uploadResult.location && typeof window.removeLocationByUrl === 'function') {
          window.removeLocationByUrl(found.uploadResult.location);
        }
      }
      return prev.filter(f => f.id !== fileId);
    });
    setError(null);
  };
  var handleDragEnter = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  var handleDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };
  var handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
  };
  var handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    var files = Array.from(e.dataTransfer.files || []);
    addFiles(files);
  };

  // update specific file entry by id
  var updateEntry = (id, patch) => {
    setFilesState(prev => prev.map(f => f.id === id ? _objectSpread(_objectSpread({}, f), patch) : f));
  };

  // Upload helpers
  var uploadSingle = /*#__PURE__*/function () {
    var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (fileEntry) {
      // Get the latest state to ensure we have the most recent file entry
      setFilesState(prev => {
        var latest = prev.find(f => f.id === fileEntry.id);
        if (!latest) return prev;

        // Don't start if already uploading, uploaded, or initializing
        if (latest.status === "uploading" || latest.status === "uploaded" || latest.status === "initializing") {
          return prev;
        }

        // Set status to initializing when starting
        var updated = prev.map(f => f.id === latest.id ? _objectSpread(_objectSpread({}, f), {}, {
          status: "initializing",
          progress: 0,
          error: null
        }) : f);

        // Start the upload asynchronously
        setTimeout(/*#__PURE__*/(0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
          var hasStartedUploading = false;
          try {
            var _latest$abortControll;
            var result = yield uploadFile(latest.file, _ref4 => {
              var {
                uploadedBytes,
                totalBytes,
                percent
              } = _ref4;
              // When first progress update comes, switch from initializing to uploading
              if (!hasStartedUploading) {
                hasStartedUploading = true;
                updateEntry(latest.id, {
                  status: "uploading"
                });
              }
              var p = typeof percent === "number" ? percent : Math.round(uploadedBytes / totalBytes * 100);
              updateEntry(latest.id, {
                progress: Math.min(100, Math.max(0, p))
              });
            }, (_latest$abortControll = latest.abortController) === null || _latest$abortControll === void 0 ? void 0 : _latest$abortControll.signal);
            updateEntry(latest.id, {
              status: "uploaded",
              progress: 100,
              uploadResult: result,
              abortController: null
            });

            // After successful upload, start the next queued upload
            setTimeout(() => {
              startNextQueuedUploadRef.current();
            }, 0);
          } catch (err) {
            var _latest$abortControll2;
            var isAbort = (err === null || err === void 0 ? void 0 : err.name) === "AbortError" || ((_latest$abortControll2 = latest.abortController) === null || _latest$abortControll2 === void 0 || (_latest$abortControll2 = _latest$abortControll2.signal) === null || _latest$abortControll2 === void 0 ? void 0 : _latest$abortControll2.aborted);
            if (isAbort) {
              updateEntry(latest.id, {
                status: "cancelled",
                error: "Cancelled by user",
                abortController: null
              });
            } else {
              var errorMessage = "Upload failed";
              if (err) {
                if (typeof err === "string") {
                  errorMessage = err;
                } else if (err.message) {
                  errorMessage = err.message;
                } else if (err.toString && typeof err.toString === "function") {
                  errorMessage = err.toString();
                } else {
                  errorMessage = String(err);
                }
              }
              console.error("Upload failed for", latest.name, err);
              updateEntry(latest.id, {
                status: "failed",
                error: errorMessage,
                abortController: null
              });
            }

            // After failed/cancelled upload, start the next queued upload
            setTimeout(() => {
              startNextQueuedUploadRef.current();
            }, 0);
          }
        }), 0);
        return updated;
      });
    });
    return function uploadSingle(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Store uploadSingle in ref so it can be accessed by startNextQueuedUpload
  uploadSingleRef.current = uploadSingle;

  // Start the next queued upload if no upload is in progress
  var startNextQueuedUpload = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    setFilesState(prev => {
      // Check if any upload is currently in progress
      var hasActiveUpload = prev.some(f => f.status === "initializing" || f.status === "uploading");
      if (hasActiveUpload) {
        return prev; // Don't start if upload is in progress
      }

      // Find the first queued file
      var queued = prev.find(f => f.status === "queued");
      if (queued && uploadSingleRef.current) {
        // Start the upload asynchronously
        setTimeout(() => {
          uploadSingleRef.current(queued);
        }, 0);
      }
      return prev; // State update handled in uploadSingle
    });
  }, []);
  var startNextQueuedUploadRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(startNextQueuedUpload);
  startNextQueuedUploadRef.current = startNextQueuedUpload;

  // When files are added, check if we should start next upload
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    startNextQueuedUpload();
  }, [filesState.length]);

  // Monitor status changes to trigger next upload when current one completes
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var currentStatusString = filesState.map(f => "".concat(f.id, "-").concat(f.status)).join(',');

    // Only process if status actually changed
    if (currentStatusString !== statusStringRef.current) {
      statusStringRef.current = currentStatusString;
      var activeUploads = filesState.filter(f => f.status === "initializing" || f.status === "uploading");
      var queuedFiles = filesState.filter(f => f.status === "queued");

      // If no active uploads and there are queued files, start the next one
      if (activeUploads.length === 0 && queuedFiles.length > 0) {
        startNextQueuedUpload();
      }
    }
  }, [filesState]);

  // Listen for add-to-cart form submissions and button clicks to allow navigation
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var handleFormSubmit = e => {
      var form = e.target.closest('form[data-type="add-to-cart-form"]');
      if (form) {
        allowNavigationRef.current = true;
        // Reset after a delay to allow the form submission to complete
        setTimeout(() => {
          allowNavigationRef.current = false;
        }, 3000);
      }
    };
    var handleButtonClick = e => {
      var target = e.target;
      var clickedElement = target.closest('a, button, [role="button"]') || target;

      // Check if clicked button is inside an add-to-cart form
      var form = target.closest('form[data-type="add-to-cart-form"]');
      var isSubmitButton = target.type === 'submit' || target.closest('button[type="submit"]');
      if (form && isSubmitButton) {
        allowNavigationRef.current = true;
        // Reset after a delay to allow the form submission to complete
        setTimeout(() => {
          allowNavigationRef.current = false;
        }, 3000);
        return;
      }

      // Check if clicked on cart notification link
      var isCartNotificationLink = clickedElement.closest('.cart-notification__link') || clickedElement.classList.contains('cart-notification__link') || target.closest('.cart-notification__link');

      // Check if clicked on header cart link
      var isHeaderCartLink = clickedElement.closest('.header-cart__link') || clickedElement.classList.contains('header-cart__link') || target.closest('.header-cart__link');
      if (isCartNotificationLink || isHeaderCartLink) {
        allowNavigationRef.current = true;
        // Reset after a delay to allow the navigation to complete
        setTimeout(() => {
          allowNavigationRef.current = false;
        }, 3000);
      }
    };

    // Listen for form submit events (capture phase to catch before preventDefault)
    document.addEventListener('submit', handleFormSubmit, true);
    // Also listen for button clicks as a fallback
    document.addEventListener('click', handleButtonClick, true);
    return () => {
      document.removeEventListener('submit', handleFormSubmit, true);
      document.removeEventListener('click', handleButtonClick, true);
    };
  }, []);

  // Show alert when page refresh/redirection is attempted during upload or after upload
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var isUploadInProgress = filesState.some(f => f.status === "initializing" || f.status === "uploading");
    var hasUploadedFiles = filesState.some(f => f.status === "uploaded");
    var shouldBlockRefresh = isUploadInProgress || hasUploadedFiles;
    var handleBeforeUnload = e => {
      // Don't show warning if navigation is allowed (e.g., add to cart was clicked)
      if (shouldBlockRefresh && !allowNavigationRef.current) {
        e.preventDefault();
        if (isUploadInProgress) {
          e.returnValue = "Uploading file will be stopped, and you need to reupload file again";
        } else {
          e.returnValue = "File upload completed. Please add to cart or view cart before leaving.";
        }
        return e.returnValue;
      }
    };
    if (shouldBlockRefresh) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }
    return () => {
      if (shouldBlockRefresh) {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      }
    };
  }, [filesState]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react__WEBPACK_IMPORTED_MODULE_2___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", {
    ref: fileInputRef,
    type: "file",
    multiple: true,
    style: {
      display: 'none'
    },
    onChange: handleFileChange
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "design-method-card design-upload-method-card  ".concat(isUploadContainerOpen ? 'design-method-card--expanded' : ''),
    role: "button",
    tabIndex: 0,
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleCardClick();
      }
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "design-method-card__header",
    onClick: handleCardClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "design-method-card__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z",
    fill: "#CD3D1C"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "design-method-card__content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h3", {
    className: "design-method-card__title"
  }, "Upload File"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("p", {
    className: "design-method-card__description"
  // AFTER (1 GB 빨간색 적용됨)
}, "Up to ",
/* red MAX_FILES */
 /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
  style: { color: "#e11d48", fontWeight: "400" }
}, MAX_FILES),
" files · Max size ",
 /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
  style: { color: "#e11d48", fontWeight: 400 }
}, "1 GB"), " each"))), /* ✅ ADD THIS RIGHT HERE */
 /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
  className: "upload-file-tips",
  style: {
    fontFamily: "Roboto, Arial, sans-serif",
    fontSize: "13px",
    lineHeight: "1.35"
  }
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("ul", null,
  /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("li", null,
 "Unlimited ",
 /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
  style: { color: "#e11d48", fontWeight: "400" }
}, "free"),
" proofs",
    " – Perfect your design until it's just right!"
  ),
  /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("li", null, "Upload your file(s) and we'll get it done."),
  /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("li", null, "One file per one item of order if possible."),
 /* replace with this */
 /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("li", null,
  "Up to ",
  /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    style: { color: "#e11d48", fontWeight: "400" }
  }, "1 Gigabyte!"),
),

)),
/* ✅ END ADD */
 /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "upload-container ".concat(isUploadContainerOpen ? 'upload-container--open' : '')
  }, filesState.length < MAX_FILES && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "upload-container__dropzone ".concat(isDragging ? 'upload-container__dropzone--dragging' : ''),
    onDragEnter: handleDragEnter,
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    onClick: e => {
      e.stopPropagation();
      handleFileInputClick();
    }
    
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "upload-container__browse-text"
  }, "Browse files")), filesState.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "upload-container__files-list"
  }, filesState.map(fileItem => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    key: fileItem.id,
    className: "upload-container__file-item tw-flex tw-items-center tw-gap-3 tw-py-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "upload-container__file-icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.59 16.43L16 15.01L12.01 11L8 15.01Z",
    fill: "#CD3D1C"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex-1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-justify-between tw-items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "upload-container__file-name"
  }, fileItem.name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-[10px] tw-text-gray-500"
  }, (fileItem.size / 1024 / 1024).toFixed(2), " MB")), fileItem.status === "initializing" ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-mt-2 tw-flex tw-items-center tw-justify-between"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-items-center tw-gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "upload-container__loader"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    className: "upload-container__loader-spinner",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "#CD3D1C",
    strokeOpacity: "0.25",
    strokeWidth: "4"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12",
    stroke: "#CD3D1C",
    strokeWidth: "4",
    strokeLinecap: "round"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "1s",
    repeatCount: "indefinite",
    values: "0 12 12;360 12 12"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-[10px] tw-text-gray-600"
  }, "Preparing upload...")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    className: "upload-container__file-delete",
    onClick: e => {
      e.stopPropagation();
      handleRemoveFile(fileItem.id);
    },
    "aria-label": "Remove file"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M5.00033 15.8333C5.00033 16.75 5.75033 17.5 6.66699 17.5H13.3337C14.2503 17.5 15.0003 16.75 15.0003 15.8333V5.83333H5.00033V15.8333ZM15.8337 3.33333H12.917L12.0837 2.5H7.91699L7.08366 3.33333H4.16699V5H15.8337V3.33333Z",
    fill: "black",
    fillOpacity: "0.56"
  })))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react__WEBPACK_IMPORTED_MODULE_2___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-mt-2 tw-h-3 tw-bg-gray-200 tw-rounded-xl"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-h-3 tw-rounded-xl tw-bg-green-500",
    style: {
      width: "".concat(Math.min(100, Math.max(0, fileItem.progress)), "%")
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-justify-between tw-items-center tw-mt-1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-[10px]"
  }, fileItem.status === "queued" && "Queued", fileItem.status === "uploading" && "Uploading \u2014 ".concat(Math.round(fileItem.progress), "%"), fileItem.status === "uploaded" && "Uploaded", fileItem.status === "failed" && "Failed: ".concat(fileItem.error || "unknown"), fileItem.status === "cancelled" && "Cancelled"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    className: "upload-container__file-delete",
    onClick: e => {
      e.stopPropagation();
      handleRemoveFile(fileItem.id);
    },
    "aria-label": "Remove file"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M5.00033 15.8333C5.00033 16.75 5.75033 17.5 6.66699 17.5H13.3337C14.2503 17.5 15.0003 16.75 15.0003 15.8333V5.83333H5.00033V15.8333ZM15.8337 3.33333H12.917L12.0837 2.5H7.91699L7.08366 3.33333H4.16699V5H15.8337V3.33333Z",
    fill: "black",
    fillOpacity: "0.56"
  }))))))))))), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "upload-error-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "upload-error-container__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
    fill: "#DC2626"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "upload-error-container__message"
  }, error), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    className: "upload-error-container__close",
    onClick: () => setError(null),
    "aria-label": "Close error"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
    fill: "#575757"
  })))));
};

/***/ }),

/***/ "./js/components/product-addons.js":
/*!*****************************************!*\
  !*** ./js/components/product-addons.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   productAddons: () => (/* binding */ productAddons)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var formatPrice = price => "$".concat((price / 100).toFixed(2));
var isValidAddon = addon => {
  return (addon === null || addon === void 0 ? void 0 : addon.id) && typeof addon.price === 'number' && !isNaN(addon.price) && addon.price !== null;
};

// Custom Dropdown component unchanged...
var CustomDropdown = _ref => {
  var {
    options,
    value,
    placeholder,
    onChange,
    disabled,
    id
  } = _ref;
  var [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var selectedOption = options.find(opt => {
    if (value === null || value === undefined || value === '') {
      return opt.value === '' || opt.value === null || opt.value === undefined;
    }
    return String(opt.value) === String(value);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  var handleSelect = optionValue => {
    onChange(optionValue);
    setIsOpen(false);
  };
  var handleButtonClick = e => {
    e.stopPropagation();
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "custom-dropdown",
    ref: dropdownRef
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    ref: buttonRef,
    type: "button",
    id: id,
    className: "custom-dropdown__button ".concat(isOpen ? 'custom-dropdown__button--open' : '', " ").concat(disabled ? 'custom-dropdown__button--disabled' : ''),
    onClick: handleButtonClick,
    disabled: disabled
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "custom-dropdown__button-text"
  }, selectedOption && selectedOption.value !== '' && selectedOption.value !== null && selectedOption.value !== undefined ? selectedOption.label : placeholder), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    className: "custom-dropdown__arrow ".concat(isOpen ? 'custom-dropdown__arrow--open' : ''),
    width: "12",
    height: "8",
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M1 1.5L6 6.5L11 1.5",
    stroke: "#000",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), isOpen && !disabled && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "custom-dropdown__options"
  }, options.map(option => {
    var isSelected = (() => {
      if (value === null || value === undefined || value === '') {
        return option.value === '' || option.value === null || option.value === undefined;
      }
      return String(option.value) === String(value);
    })();
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      key: option.value !== null && option.value !== undefined ? String(option.value) : 'empty',
      className: "custom-dropdown__option ".concat(isSelected ? 'custom-dropdown__option--selected' : '', " ").concat(option.disabled ? 'custom-dropdown__option--disabled' : ''),
      onClick: () => !option.disabled && handleSelect(option.value)
    }, option.label);
  })));
};
var isValidProductLevelAddon = addon => {
  return (addon === null || addon === void 0 ? void 0 : addon.productId) && Array.isArray(addon.variants) && addon.variants.length > 0;
};
var productAddons = _ref2 => {
  var {
    shopifyData
  } = _ref2;
  var [selectedAddons, setSelectedAddons] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(new Set());
  var [selectedVariantId, setSelectedVariantId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
  var [selectedVariants, setSelectedVariants] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(new Map());
  var [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [mainQuantity, setMainQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1); // <-- new state for main product quantity
  var [resetKey, setResetKey] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0); // Key to force re-render of dropdowns on reset
  // Initialize with data from shopifyData, but will be updated dynamically as variants change
  var [variantAddonsData, setVariantAddonsData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(() => shopifyData.variantAddons || {});
  var variantInputRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var productFormRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var loadingStartTimeRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var isFetchingAddonsRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var sectionSelectors = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => ({
    variantSelects: "variant-selects[data-section=\"".concat(shopifyData.sectionId, "\"]"),
    productForm: "#product-form-".concat(shopifyData.sectionId),
    variantInput: 'input[name="id"]'
  }), [shopifyData.sectionId]);
  var getVariantIdFromURL = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    var urlParams = new URLSearchParams(window.location.search);
    var variantParam = urlParams.get('variant');
    if (variantParam) {
      var variantId = parseInt(variantParam, 10);
      return variantId || null;
    }
    var variantSelects = document.querySelector(sectionSelectors.variantSelects);
    var variantInput = variantSelects === null || variantSelects === void 0 ? void 0 : variantSelects.querySelector(sectionSelectors.variantInput);
    if (variantInput !== null && variantInput !== void 0 && variantInput.value) {
      return parseInt(variantInput.value, 10);
    }
    var productForm = document.querySelector(sectionSelectors.productForm);
    var formVariantInput = productForm === null || productForm === void 0 ? void 0 : productForm.querySelector(sectionSelectors.variantInput);
    if (formVariantInput !== null && formVariantInput !== void 0 && formVariantInput.value) {
      return parseInt(formVariantInput.value, 10);
    }
    return null;
  }, [sectionSelectors]);

  // Fetch addons data for a specific variant via API
  var fetchAddonsForVariant = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/function () {
    var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (variantId) {
      if (!variantId || isFetchingAddonsRef.current || !shopifyData.productUrl) {
        return null;
      }

      // Check if we already have addons data for this variant
      if (variantAddonsData[variantId] || variantAddonsData[String(variantId)] || variantAddonsData[variantId.toString()]) {
        return variantAddonsData;
      }
      isFetchingAddonsRef.current = true;
      try {
        // Fetch the section with variant parameter to get addons for this variant
        var url = "".concat(shopifyData.productUrl, "?section_id=").concat(shopifyData.sectionId, "&variant=").concat(variantId);
        var response = yield fetch(url);
        if (!response.ok) {
          throw new Error("HTTP error! status: ".concat(response.status));
        }
        var htmlText = yield response.text();
        var html = new DOMParser().parseFromString(htmlText, 'text/html');

        // Find the product-addons element in the response
        var addonsElement = html.querySelector("product-addons[data-section=\"".concat(shopifyData.sectionId, "\"]"));
        if (!addonsElement) {
          isFetchingAddonsRef.current = false;
          return null;
        }

        // Extract the addons data from the JSON script
        var addonsDataScript = addonsElement.querySelector('#product-addons-data');
        if (!addonsDataScript) {
          isFetchingAddonsRef.current = false;
          return null;
        }
        try {
          var addonsData = JSON.parse(addonsDataScript.textContent);
          if (addonsData && addonsData.variantAddons) {
            // Merge the new addons data with existing data
            setVariantAddonsData(prev => _objectSpread(_objectSpread({}, prev), addonsData.variantAddons));
            return addonsData.variantAddons;
          }
        } catch (parseError) {
          console.error('Error parsing addons data:', parseError);
        }
      } catch (error) {
        console.error('Error fetching addons for variant:', error);
      } finally {
        isFetchingAddonsRef.current = false;
      }
      return null;
    });
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [shopifyData.productUrl, shopifyData.sectionId, variantAddonsData]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var lastVariantId = null;
    var checkVariantChange = /*#__PURE__*/function () {
      var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* () {
        var currentVariantId = getVariantIdFromURL();
        if (currentVariantId !== lastVariantId) {
          lastVariantId = currentVariantId;
          loadingStartTimeRef.current = Date.now();
          setIsLoading(true);

          // Fetch addons data for the new variant
          yield fetchAddonsForVariant(currentVariantId);
          Promise.resolve().then(() => {
            requestAnimationFrame(() => {
              setSelectedVariantId(currentVariantId);
              setSelectedAddons(new Set());
              setSelectedVariants(new Map());
            });
          });
        }
      });
      return function checkVariantChange() {
        return _ref4.apply(this, arguments);
      };
    }();
    checkVariantChange();
    var handlePopState = () => checkVariantChange();
    window.addEventListener('popstate', handlePopState);
    var handleVariantSelectChange = () => setTimeout(checkVariantChange, 100);
    document.addEventListener('variant:change', handleVariantSelectChange);
    var variantSelects = document.querySelector(sectionSelectors.variantSelects);
    var handleVariantChange = null;
    if (variantSelects) {
      var variantInput = variantSelects.querySelector(sectionSelectors.variantInput);
      if (variantInput) {
        variantInputRef.current = variantInput;
        handleVariantChange = () => setTimeout(checkVariantChange, 100);
        variantInput.addEventListener('change', handleVariantChange);
        variantInput.addEventListener('input', handleVariantChange);
      }
    }
    var pollInterval = setInterval(checkVariantChange, 300);
    return () => {
      clearInterval(pollInterval);
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('variant:change', handleVariantSelectChange);
      if (variantInputRef.current && handleVariantChange) {
        variantInputRef.current.removeEventListener('change', handleVariantChange);
        variantInputRef.current.removeEventListener('input', handleVariantChange);
        variantInputRef.current = null;
      }
    };
  }, [shopifyData.sectionId, getVariantIdFromURL, sectionSelectors, fetchAddonsForVariant]);

  // --- New effect: watch main product quantity input and keep mainQuantity in state ---
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var productFormSelector = sectionSelectors.productForm;
    var productForm = document.querySelector(productFormSelector);
    productFormRef.current = productForm;
    var updateQuantityFromForm = () => {
      if (!productForm) return;
      var qtyInput = productForm.querySelector('input[name="quantity"]');
      if (!qtyInput) return;
      var value = parseInt(qtyInput.value, 10);
      if (!isNaN(value) && value > 0) {
        setMainQuantity(value);
      } else {
        setMainQuantity(1);
      }
    };

    // initialize once
    updateQuantityFromForm();
    if (productForm) {
      var qtyInput = productForm.querySelector('input[name="quantity"]');
      if (qtyInput) {
        qtyInput.addEventListener('input', updateQuantityFromForm);
        qtyInput.addEventListener('change', updateQuantityFromForm);
      }
    }
    return () => {
      if (productForm) {
        var _qtyInput = productForm.querySelector('input[name="quantity"]');
        if (_qtyInput) {
          _qtyInput.removeEventListener('input', updateQuantityFromForm);
          _qtyInput.removeEventListener('change', updateQuantityFromForm);
        }
      }
    };
  }, [sectionSelectors.productForm]);

  // Determine mode and addons - use dynamically loaded variantAddonsData
  var {
    mode,
    variantLevelAddons,
    productLevelAddons
  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (!selectedVariantId || !variantAddonsData) {
      return {
        mode: null,
        variantLevelAddons: [],
        productLevelAddons: []
      };
    }
    var variantData = variantAddonsData[selectedVariantId] || variantAddonsData[String(selectedVariantId)] || variantAddonsData[selectedVariantId.toString()] || null;
    if (!variantData) {
      return {
        mode: null,
        variantLevelAddons: [],
        productLevelAddons: []
      };
    }
    var variantLevel = Array.isArray(variantData.variantLevel) ? variantData.variantLevel.filter(isValidAddon) : [];
    var productLevel = Array.isArray(variantData.productLevel) ? variantData.productLevel.filter(isValidProductLevelAddon) : [];
    var activeMode = null;
    if (variantLevel.length > 0) {
      activeMode = 'variant_level';
    } else if (productLevel.length > 0) {
      activeMode = 'product_level';
    }
    return {
      mode: activeMode,
      variantLevelAddons: variantLevel,
      productLevelAddons: productLevel
    };
  }, [selectedVariantId, variantAddonsData]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (selectedVariantId && loadingStartTimeRef.current !== null) {
      var minLoadingTime = 300;
      var startTime = loadingStartTimeRef.current;
      var clearLoading = () => {
        var elapsed = Date.now() - startTime;
        var remainingTime = Math.max(0, minLoadingTime - elapsed);
        var timer = setTimeout(() => {
          setIsLoading(false);
          loadingStartTimeRef.current = null;
        }, remainingTime);
        return timer;
      };
      var timer;
      if (mode !== null) {
        timer = clearLoading();
      } else {
        var elapsed = Date.now() - startTime;
        var remainingTime = Math.max(minLoadingTime, 200) - elapsed;
        timer = setTimeout(() => {
          setIsLoading(false);
          loadingStartTimeRef.current = null;
        }, Math.max(remainingTime, 0));
      }
      return () => {
        if (timer) clearTimeout(timer);
      };
    }
  }, [selectedVariantId, mode]);

  // Helper function to build addon data from provided state
  var buildAddonData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((addonsSet, variantsMap) => {
    if (!selectedVariantId || !variantAddonsData) {
      return [];
    }
    var variantData = variantAddonsData[selectedVariantId] || variantAddonsData[String(selectedVariantId)] || variantAddonsData[selectedVariantId.toString()] || null;
    if (!variantData) {
      return [];
    }
    var variantLevelAddons = Array.isArray(variantData.variantLevel) ? variantData.variantLevel : [];
    var productLevelAddons = Array.isArray(variantData.productLevel) ? variantData.productLevel : [];
    var addonsToSend = [];

    // Use provided state or fallback to current state
    var currentAddons = addonsSet || selectedAddons;
    var currentVariants = variantsMap || selectedVariants;

    // Process variant level addons
    if (variantLevelAddons.length > 0 && currentAddons.size > 0) {
      currentAddons.forEach(addonId => {
        var addon = variantLevelAddons.find(a => a.id === addonId || a.id === parseInt(addonId, 10) || String(a.id) === String(addonId));
        if (addon) {
          addonsToSend.push({
            id: addon.id,
            variantId: addon.id,
            // For variant-level, id is the variantId
            productId: null,
            productTitle: addon.productTitle,
            variantTitle: addon.variantTitle,
            image: addon.image
          });
        }
      });
    }

    // Process product level addons
    if (productLevelAddons.length > 0 && currentAddons.size > 0) {
      currentAddons.forEach(productId => {
        var productIdNum = parseInt(productId, 10);
        var addon = productLevelAddons.find(a => a.productId === productIdNum);
        var variantId = currentVariants.get(productIdNum);
        if (addon && variantId) {
          var _addon$variants;
          var variant = (_addon$variants = addon.variants) === null || _addon$variants === void 0 ? void 0 : _addon$variants.find(v => v.id === variantId);
          addonsToSend.push({
            id: addon.productId,
            variantId: variantId,
            productId: productIdNum,
            productTitle: addon.productTitle,
            variantTitle: (variant === null || variant === void 0 ? void 0 : variant.title) || 'Default',
            image: addon.image
          });
        }
      });
    }
    return addonsToSend;
  }, [selectedVariantId, variantAddonsData, selectedAddons, selectedVariants]);

  // Function to notify product-form about selected addons
  var notifyProductForm = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function (addons) {
    var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    // Try multiple selectors to find the product-form custom element
    var productSection = document.querySelector("[data-section=\"".concat(shopifyData.sectionId, "\"]"));
    var productForm = null;

    // First try: find product-form custom element within the section
    if (productSection) {
      productForm = productSection.querySelector('product-form');
    }

    // Fallback: try the form selector and find parent product-form
    if (!productForm) {
      var form = document.querySelector(sectionSelectors.productForm);
      if (form) {
        productForm = form.closest('product-form');
      }
    }

    // Last resort: find any product-form in the section
    if (!productForm && productSection) {
      productForm = productSection.querySelector('product-form');
    }
    if (productForm && typeof productForm.updateSelectedAddons === 'function') {
      productForm.updateSelectedAddons(addons);
      return true;
    } else if (retries > 0) {
      // Retry if element not found yet
      setTimeout(() => notifyProductForm(addons, retries - 1), 200);
      return false;
    }
    return false;
  }, [sectionSelectors.productForm, shopifyData.sectionId]);
  var handleAddonToggle = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(addonId => {
    setSelectedAddons(prev => {
      var newSet = new Set(prev);
      var wasSelected = newSet.has(addonId);
      if (wasSelected) {
        newSet.delete(addonId);
        setSelectedVariants(prevVariants => {
          var newVariants = new Map(prevVariants);
          newVariants.delete(addonId);

          // Build and send addon data immediately with new state
          var addonsToSend = buildAddonData(newSet, newVariants);
          notifyProductForm(addonsToSend);
          return newVariants;
        });
      } else {
        newSet.add(addonId);

        // Build and send addon data immediately with new state
        var addonsToSend = buildAddonData(newSet, selectedVariants);
        notifyProductForm(addonsToSend);
      }
      setTimeout(() => {
        if (!selectedVariantId || !variantAddonsData) {
          return;
        }
        var variantData = variantAddonsData[selectedVariantId] || variantAddonsData[String(selectedVariantId)] || variantAddonsData[selectedVariantId.toString()] || null;
        if (!variantData) {
          return;
        }
        var productSection = document.querySelector("[data-section=\"".concat(shopifyData.sectionId, "\"]"));
        if (!productSection) {
          return;
        }
        var addonsVariantSelect = productSection.querySelector('.addons-variant-select');
        if (!addonsVariantSelect) {
          return;
        }
        var optionsList = addonsVariantSelect.querySelector('.product-form__controls-group');
        if (!optionsList) {
          return;
        }
        var selectLabel = addonsVariantSelect.querySelector('.select-label span');
        var hiddenInput = addonsVariantSelect.querySelector('input[data-custom-variant-input="true"]');
        var allFinishingOptions = new Set();

        // Check variant-level addons
        if (newSet.size > 0 && variantData.variantLevel && Array.isArray(variantData.variantLevel)) {
          var _variantLevelAddons = variantData.variantLevel.filter(isValidAddon);
          var _loop = function _loop(selectedAddonId) {
            var addon = _variantLevelAddons.find(a => a.id === selectedAddonId);
            if (addon && addon.finishingOptionsVisible) {
              var _addon$finishingOptio;
              var options = [];
              if (Array.isArray(addon.finishingOptionsVisible)) {
                options = addon.finishingOptionsVisible;
              } else if ((_addon$finishingOptio = addon.finishingOptionsVisible) !== null && _addon$finishingOptio !== void 0 && _addon$finishingOptio.value && Array.isArray(addon.finishingOptionsVisible.value)) {
                options = addon.finishingOptionsVisible.value;
              }
              options.forEach(opt => {
                if (opt != null && opt !== '') {
                  allFinishingOptions.add(String(opt).trim());
                }
              });
            }
          };
          for (var selectedAddonId of newSet) {
            _loop(selectedAddonId);
          }
        }

        // Check product-level addons - look at selected variants' finishingOptionsVisible
        if (variantData.productLevel && Array.isArray(variantData.productLevel)) {
          var _productLevelAddons = variantData.productLevel.filter(isValidProductLevelAddon);
          var _loop2 = function _loop2(selectedProductId, selectedAddonVariantId) {
            var addon = _productLevelAddons.find(a => a.productId === selectedProductId || a.productId === parseInt(selectedProductId, 10));
            if (addon && addon.variants && selectedAddonVariantId) {
              var selectedVariant = addon.variants.find(v => v.id === selectedAddonVariantId);
              if (selectedVariant && selectedVariant.finishingOptionsVisible) {
                var _selectedVariant$fini;
                var options = [];
                if (Array.isArray(selectedVariant.finishingOptionsVisible)) {
                  options = selectedVariant.finishingOptionsVisible;
                } else if ((_selectedVariant$fini = selectedVariant.finishingOptionsVisible) !== null && _selectedVariant$fini !== void 0 && _selectedVariant$fini.value && Array.isArray(selectedVariant.finishingOptionsVisible.value)) {
                  options = selectedVariant.finishingOptionsVisible.value;
                }
                options.forEach(opt => {
                  if (opt != null && opt !== '') {
                    allFinishingOptions.add(String(opt).trim());
                  }
                });
              }
            }
          };
          for (var [selectedProductId, selectedAddonVariantId] of selectedVariants) {
            _loop2(selectedProductId, selectedAddonVariantId);
          }
        }
        var normalizedOptions = Array.from(allFinishingOptions);
        var existingOptions = optionsList.querySelectorAll('li');
        var hasSelectedAddons = newSet.size > 0 || selectedVariants.size > 0;
        if (hasSelectedAddons && normalizedOptions.length > 0) {
          existingOptions.forEach(li => {
            var optionValue = String(li.dataset.value || '').trim();
            var shouldShow = normalizedOptions.includes(optionValue);
            li.style.display = shouldShow ? '' : 'none';
            if (!shouldShow) {
              var radio = li.querySelector('input[type="radio"]');
              if (radio && radio.checked) {
                radio.checked = false;
                if (hiddenInput) hiddenInput.value = '';
                if (selectLabel) {
                  var placeholder = (hiddenInput === null || hiddenInput === void 0 ? void 0 : hiddenInput.dataset.placeholderText) || '';
                  selectLabel.textContent = placeholder;
                }
              }
            }
          });
        } else {
          existingOptions.forEach(li => {
            li.style.display = '';
          });
        }
      }, 50);
      return newSet;
    });
  }, [variantAddonsData, selectedVariantId, selectedVariants, notifyProductForm, buildAddonData, shopifyData.sectionId]);

  // Update product-form when addons selection changes (backup/sync)
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var addonsToSend = buildAddonData(selectedAddons, selectedVariants);
    notifyProductForm(addonsToSend);
  }, [selectedAddons, selectedVariants, selectedVariantId, variantAddonsData, buildAddonData, notifyProductForm]);
  var handleVariantSelect = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((productId, variantId) => {
    setSelectedVariants(prev => {
      var newMap = new Map(prev);
      if (variantId) {
        newMap.set(productId, variantId);
      } else {
        newMap.delete(productId);
      }

      // Immediately notify product-form with updated addons after variant change
      var addonsToSend = buildAddonData(selectedAddons, newMap);
      notifyProductForm(addonsToSend);

      // Update finishing options visibility for product-level addons
      setTimeout(() => {
        if (!selectedVariantId || !variantAddonsData) {
          return;
        }
        var variantData = variantAddonsData[selectedVariantId] || variantAddonsData[String(selectedVariantId)] || variantAddonsData[selectedVariantId.toString()] || null;
        if (!variantData) {
          return;
        }
        var productSection = document.querySelector("[data-section=\"".concat(shopifyData.sectionId, "\"]"));
        if (!productSection) {
          return;
        }
        var addonsVariantSelect = productSection.querySelector('.addons-variant-select');
        if (!addonsVariantSelect) {
          return;
        }
        var optionsList = addonsVariantSelect.querySelector('.product-form__controls-group');
        if (!optionsList) {
          return;
        }
        var selectLabel = addonsVariantSelect.querySelector('.select-label span');
        var hiddenInput = addonsVariantSelect.querySelector('input[data-custom-variant-input="true"]');
        var allFinishingOptions = new Set();

        // Check variant-level addons
        if (variantData.variantLevel && Array.isArray(variantData.variantLevel)) {
          var _variantLevelAddons2 = variantData.variantLevel.filter(isValidAddon);
          var _loop3 = function _loop3(selectedAddonId) {
            var addon = _variantLevelAddons2.find(a => a.id === selectedAddonId);
            if (addon && addon.finishingOptionsVisible) {
              var _addon$finishingOptio2;
              var options = [];
              if (Array.isArray(addon.finishingOptionsVisible)) {
                options = addon.finishingOptionsVisible;
              } else if ((_addon$finishingOptio2 = addon.finishingOptionsVisible) !== null && _addon$finishingOptio2 !== void 0 && _addon$finishingOptio2.value && Array.isArray(addon.finishingOptionsVisible.value)) {
                options = addon.finishingOptionsVisible.value;
              }
              options.forEach(opt => {
                if (opt != null && opt !== '') {
                  allFinishingOptions.add(String(opt).trim());
                }
              });
            }
          };
          for (var selectedAddonId of selectedAddons) {
            _loop3(selectedAddonId);
          }
        }

        // Check product-level addons - look at the selected variant's finishingOptionsVisible
        if (variantData.productLevel && Array.isArray(variantData.productLevel)) {
          var _productLevelAddons2 = variantData.productLevel.filter(isValidProductLevelAddon);

          // Iterate through all selected product-level addons in newMap
          var _loop4 = function _loop4(selectedProductId, selectedAddonVariantId) {
            var addon = _productLevelAddons2.find(a => a.productId === selectedProductId || a.productId === parseInt(selectedProductId, 10));
            if (addon && addon.variants && selectedAddonVariantId) {
              // Find the selected variant within this addon product
              var selectedVariant = addon.variants.find(v => v.id === selectedAddonVariantId);
              if (selectedVariant && selectedVariant.finishingOptionsVisible) {
                var _selectedVariant$fini2;
                var options = [];
                if (Array.isArray(selectedVariant.finishingOptionsVisible)) {
                  options = selectedVariant.finishingOptionsVisible;
                } else if ((_selectedVariant$fini2 = selectedVariant.finishingOptionsVisible) !== null && _selectedVariant$fini2 !== void 0 && _selectedVariant$fini2.value && Array.isArray(selectedVariant.finishingOptionsVisible.value)) {
                  options = selectedVariant.finishingOptionsVisible.value;
                }
                options.forEach(opt => {
                  if (opt != null && opt !== '') {
                    allFinishingOptions.add(String(opt).trim());
                  }
                });
              }
            }
          };
          for (var [selectedProductId, selectedAddonVariantId] of newMap) {
            _loop4(selectedProductId, selectedAddonVariantId);
          }
        }
        var normalizedOptions = Array.from(allFinishingOptions);
        var existingOptions = optionsList.querySelectorAll('li');

        // Only filter if we have addons selected AND they have finishing options
        var hasSelectedAddons = selectedAddons.size > 0 || newMap.size > 0;
        if (hasSelectedAddons && normalizedOptions.length > 0) {
          existingOptions.forEach(li => {
            var optionValue = String(li.dataset.value || '').trim();
            var shouldShow = normalizedOptions.includes(optionValue);
            li.style.display = shouldShow ? '' : 'none';
            if (!shouldShow) {
              var radio = li.querySelector('input[type="radio"]');
              if (radio && radio.checked) {
                radio.checked = false;
                if (hiddenInput) hiddenInput.value = '';
                if (selectLabel) {
                  var placeholder = (hiddenInput === null || hiddenInput === void 0 ? void 0 : hiddenInput.dataset.placeholderText) || '';
                  selectLabel.textContent = placeholder;
                }
              }
            }
          });
        } else {
          // Show all options when no addons selected or no finishing options defined
          existingOptions.forEach(li => {
            li.style.display = '';
          });
        }
      }, 50);
      return newMap;
    });
  }, [buildAddonData, notifyProductForm, selectedAddons, selectedVariantId, variantAddonsData, shopifyData.sectionId]);
  var updateCartDrawer = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/(0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* () {
    var _window$routes;
    if (typeof window.publish !== 'undefined' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-addons'
      });
      return;
    }
    if (!((_window$routes = window.routes) !== null && _window$routes !== void 0 && _window$routes.cart_url)) return;
    try {
      var sectionsUrl = "".concat(window.routes.cart_url, "?section_id=cart-drawer&section_id=cart-icon-bubble");
      var response = yield fetch(sectionsUrl);
      if (!response.ok) {
        return;
      }
      var responseText = yield response.text();
      var html = new DOMParser().parseFromString(responseText, 'text/html');
      var cartDrawerSection = html.querySelector('.shopify-section[data-section-type="cart-drawer"], #cart-drawer');
      var cartIconBubbleSection = html.querySelector('.shopify-section[data-section-type="cart-icon-bubble"], #cart-icon-bubble');
      if (cartDrawerSection) {
        var cartDrawerInner = document.querySelector('#CartDrawer .cart-drawer__inner');
        if (cartDrawerInner) {
          var sectionInner = cartDrawerSection.querySelector('.cart-drawer__inner');
          if (sectionInner) {
            cartDrawerInner.innerHTML = sectionInner.innerHTML;
          }
        } else {
          var cartDrawerEl = document.querySelector('#CartDrawer');
          if (cartDrawerEl) {
            cartDrawerEl.innerHTML = cartDrawerSection.innerHTML;
          }
        }
      }
      if (cartIconBubbleSection) {
        var cartIconBubbleEl = document.getElementById('cart-icon-bubble');
        if (cartIconBubbleEl) {
          cartIconBubbleEl.innerHTML = cartIconBubbleSection.innerHTML;
        }
      }
    } catch (error) {
      // Silently handle error
    }
  }), []);

  // Reset function to clear all selected addons
  var resetSelectedAddons = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    // Force reset by creating new empty collections
    setSelectedAddons(() => new Set());
    setSelectedVariants(() => new Map());
    // Increment reset key to force re-render of dropdowns
    setResetKey(prev => prev + 1);
    // Notify product-form that addons are cleared
    notifyProductForm([]);
  }, [notifyProductForm]);

  // Expose reset function on container element
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var productAddonsElement = document.querySelector("product-addons[data-section=\"".concat(shopifyData.sectionId, "\"]"));
    if (productAddonsElement) {
      containerRef.current = productAddonsElement;
      // Expose reset function on the element
      productAddonsElement.resetAddons = resetSelectedAddons;
    }
  }, [resetSelectedAddons, shopifyData.sectionId]);

  // Clear addons after successful cart addition (listening to cartUpdate event)
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var handleCartUpdate = event => {
      // Only reset when products are successfully added from product-form
      if (event && event.source !== 'product-form') {
        return;
      }

      // Clear selections after product is successfully added to cart
      // Use a small delay to ensure all async operations complete
      setTimeout(() => {
        resetSelectedAddons();
      }, 300);
    };
    if (typeof window.subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
      var unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
      return () => {
        if (unsubscribe) unsubscribe();
      };
    }
  }, [resetSelectedAddons]);

  // Also listen for custom reset event as a backup
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var handleResetEvent = () => {
      resetSelectedAddons();
    };
    var productAddonsElement = document.querySelector("product-addons[data-section=\"".concat(shopifyData.sectionId, "\"]"));
    if (productAddonsElement) {
      productAddonsElement.addEventListener('reset-addons', handleResetEvent);
      return () => {
        productAddonsElement.removeEventListener('reset-addons', handleResetEvent);
      };
    }
  }, [resetSelectedAddons, shopifyData.sectionId]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var priceElement = document.querySelector('.price--product');
    if (!priceElement || !selectedVariantId) {
      return;
    }
    var getCurrentVariantPrice = () => {
      var salePriceElement = priceElement.querySelector('.price__sale .price-item--sale');
      var regularPriceElement = priceElement.querySelector('.price__regular .price-item--regular');
      var priceText = '';
      if (salePriceElement) {
        priceText = salePriceElement.textContent.trim();
      } else if (regularPriceElement) {
        priceText = regularPriceElement.textContent.trim();
      }
      var cleanPriceText = priceText.replace(/[^\d.,]/g, '');
      var numericValue = cleanPriceText.replace(/,/g, '');
      var priceValue = parseFloat(numericValue);
      if (isNaN(priceValue)) return {
        price: 0,
        compareAtPrice: 0
      };
      var priceInCents = Math.round(priceValue * 100);
      var compareAtPrice = 0;
      var comparePriceElement = priceElement.querySelector('.price__compare .price-item--regular');
      if (comparePriceElement) {
        var compareText = comparePriceElement.textContent.trim();
        var cleanCompareText = compareText.replace(/[^\d.,]/g, '');
        var numericCompareValue = cleanCompareText.replace(/,/g, '');
        var compareValue = parseFloat(numericCompareValue);
        if (!isNaN(compareValue)) {
          compareAtPrice = Math.round(compareValue * 100);
        }
      }
      return {
        price: priceInCents,
        compareAtPrice
      };
    };

    // --- Calculate addon totals for 1 quantity only ---
    var calculateAddonTotals = () => {
      var totalPrice = 0;
      var totalCompareAtPrice = 0;
      if (mode === 'variant_level') {
        selectedAddons.forEach(addonId => {
          var addon = variantLevelAddons.find(a => a.id === addonId);
          if (addon && isValidAddon(addon)) {
            totalPrice += addon.price || 0;
            if (addon.compareAtPrice && addon.compareAtPrice > 0) {
              totalCompareAtPrice += addon.compareAtPrice || 0;
            }
          }
        });
      } else if (mode === 'product_level') {
        selectedAddons.forEach(productId => {
          var variantId = selectedVariants.get(productId);
          if (variantId) {
            var addon = productLevelAddons.find(a => a.productId === productId);
            if (addon) {
              var variant = addon.variants.find(v => v.id === variantId);
              if (variant) {
                totalPrice += variant.price || 0;
                if (variant.compareAtPrice && variant.compareAtPrice > 0) {
                  totalCompareAtPrice += variant.compareAtPrice || 0;
                }
              }
            }
          }
        });
      }
      return {
        totalPrice,
        totalCompareAtPrice
      };
    };
    var updatePriceDisplay = () => {
      var storedVariantId = priceElement.dataset.variantId;
      if (!storedVariantId || storedVariantId !== selectedVariantId.toString()) {
        var currentPrice = getCurrentVariantPrice();
        priceElement.dataset.originalPrice = currentPrice.price.toString();
        priceElement.dataset.originalCompareAtPrice = currentPrice.compareAtPrice.toString();
        priceElement.dataset.variantId = selectedVariantId.toString();
      }
      var originalPrice = parseInt(priceElement.dataset.originalPrice) || 0;
      var originalCompareAtPrice = parseInt(priceElement.dataset.originalCompareAtPrice) || 0;
      var {
        totalPrice,
        totalCompareAtPrice
      } = calculateAddonTotals();
      var newPrice = originalPrice + totalPrice;
      var newCompareAtPrice = originalCompareAtPrice + totalCompareAtPrice;
      var hasOnSaleClass = priceElement.classList.contains('price--on-sale');
      var salePriceElement = priceElement.querySelector('.price__sale .price-item--sale');
      var regularPriceElement = priceElement.querySelector('.price__regular .price-item--regular');
      var comparePriceElement = priceElement.querySelector('.price__compare .price-item--regular');
      if (selectedAddons.size > 0) {
        if (hasOnSaleClass && salePriceElement) {
          salePriceElement.textContent = formatPrice(newPrice);
        } else if (regularPriceElement) {
          regularPriceElement.textContent = formatPrice(newPrice);
        }
        if (hasOnSaleClass && newCompareAtPrice > 0 && comparePriceElement) {
          comparePriceElement.textContent = formatPrice(newCompareAtPrice);
        }
      } else {
        if (hasOnSaleClass && salePriceElement) {
          salePriceElement.textContent = formatPrice(originalPrice);
        } else if (regularPriceElement) {
          regularPriceElement.textContent = formatPrice(originalPrice);
        }
        if (hasOnSaleClass && originalCompareAtPrice > 0 && comparePriceElement) {
          comparePriceElement.textContent = formatPrice(originalCompareAtPrice);
        }
      }
    };
    var timeoutId = setTimeout(updatePriceDisplay, 100);
    var handleVariantPriceUpdate = () => {
      delete priceElement.dataset.variantId;
      setTimeout(updatePriceDisplay, 150);
    };
    document.addEventListener('variant:change', handleVariantPriceUpdate);
    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('variant:change', handleVariantPriceUpdate);
    };
  }, [selectedAddons, selectedVariants, selectedVariantId, mode, variantLevelAddons, productLevelAddons]);

  // Loader render unchanged
  if (isLoading) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("legend", {
      className: "product-addons__heading product-form__group-name"
    }, shopifyData.title, ":"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__grid product-addons__grid--loading"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__loading-overlay"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__loading-spinner"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__spinner"
    })))));
  }
  if (!selectedVariantId || !mode) {
    return null;
  }
  var isAddonSelected = addonId => selectedAddons.has(addonId);

  // Render variant-level addons (unchanged except addToCart usage is centralized)
  if (mode === 'variant_level' && variantLevelAddons.length > 0) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("legend", {
      className: "product-addons__heading product-form__group-name"
    }, shopifyData.title, ":"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__grid ".concat(isLoading ? 'product-addons__grid--loading' : '')
    }, isLoading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__loading-overlay"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__loading-spinner"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__spinner"
    }))), variantLevelAddons.map((addon, index) => {
      var isSelected = isAddonSelected(addon.id);
      var isAvailable = addon.available !== false;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        key: "addon-".concat(selectedVariantId, "-").concat(addon.id || index),
        className: "product-addon-card ".concat(isSelected ? 'product-addon-card--selected' : '', " ").concat(!isAvailable ? 'product-addon-card--disabled' : ''),
        "data-variant-id": addon.id,
        onClick: () => isAvailable && handleAddonToggle(addon.id),
        style: {
          cursor: isAvailable ? 'pointer' : 'not-allowed'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", {
        type: "checkbox",
        id: "addon-".concat(addon.id),
        name: "addons",
        value: addon.id,
        className: "product-addon-card__checkbox",
        checked: isSelected,
        disabled: !isAvailable,
        onChange: () => isAvailable && handleAddonToggle(addon.id),
        style: {
          display: 'none'
        }
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__label"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__content"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__image"
      }, addon.image ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("img", {
        src: addon.image,
        alt: "".concat(addon.productTitle, " - ").concat(addon.variantTitle),
        width: "48",
        height: "48",
        loading: "lazy"
      }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__placeholder"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2",
        ry: "2"
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("circle", {
        cx: "8.5",
        cy: "8.5",
        r: "1.5"
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("polyline", {
        points: "21,15 16,10 5,21"
      })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__details"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("p", {
        className: "product-addon-card__product-title"
      }, addon.productTitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("p", {
        className: "product-addon-card__variant-title"
      }, addon.variantTitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__price"
      }, addon.compareAtPrice && addon.compareAtPrice > addon.price ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "price price--on-sale"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "visually-hidden"
      }, "Sale price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "price-item price-item--sale price-item--last"
      }, formatPrice(addon.price)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "visually-hidden"
      }, "Regular price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("s", {
        className: "price-item price-item--regular"
      }, formatPrice(addon.compareAtPrice || addon.price))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "price"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "visually-hidden"
      }, "Regular price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "price-item price-item--regular"
      }, formatPrice(addon.price)))), !addon.available && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("p", {
        className: "product-addon-card__availability product-addon-card__availability--unavailable"
      }, "Sold out")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__checkbox-icon ".concat(isSelected ? 'product-addon-card__checkbox-icon--selected' : '')
      }, isSelected && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
        className: "product-addon-card__checkbox-icon-checkmark",
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "11",
        viewBox: "0 0 15 11",
        fill: "none"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.3794 0.307426C14.5763 0.50433 14.6869 0.771353 14.6869 1.04978C14.6869 1.3282 14.5763 1.59522 14.3794 1.79213L5.97945 10.1921C5.78254 10.389 5.51552 10.4996 5.2371 10.4996C4.95868 10.4996 4.69165 10.389 4.49475 10.1921L0.294747 5.99213C0.103481 5.79409 -0.00235265 5.52886 3.96928e-05 5.25355C0.00243203 4.97825 0.112859 4.71489 0.307538 4.52022C0.502217 4.32554 0.765569 4.21511 1.04088 4.21272C1.31618 4.21033 1.58141 4.31616 1.77945 4.50743L5.2371 7.96508L12.8947 0.307426C13.0917 0.110581 13.3587 0 13.6371 0C13.9155 0 14.1825 0.110581 14.3794 0.307426Z",
        fill: "white"
      }))));
    })));
  }

  // Render product-level addons (prices reflect mainQuantity)
  if (mode === 'product_level' && productLevelAddons.length > 0) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("legend", {
      className: "product-addons__heading product-form__group-name"
    }, shopifyData.title, ":"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__grid ".concat(isLoading ? 'product-addons__grid--loading' : '')
    }, isLoading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__loading-overlay"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-addons__loading-spinner"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
      className: "product-addons__spinner-icon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("circle", {
      className: "product-addons__spinner-circle",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeDasharray: "31.416",
      strokeDashoffset: "31.416"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("animate", {
      attributeName: "stroke-dasharray",
      dur: "2s",
      values: "0 31.416;15.708 15.708;0 31.416;0 31.416",
      repeatCount: "indefinite"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("animate", {
      attributeName: "stroke-dashoffset",
      dur: "2s",
      values: "0;-15.708;-31.416;-31.416",
      repeatCount: "indefinite"
    }))))), productLevelAddons.map((addon, index) => {
      var selectedAddonVariantId = selectedVariants.get(addon.productId);
      var selectedVariant = selectedAddonVariantId ? addon.variants.find(v => v.id === selectedAddonVariantId) : null;
      var isSelected = selectedAddonVariantId !== undefined && selectedAddonVariantId !== null;
      var hasAvailableVariant = addon.variants.some(v => v.available !== false);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        key: "addon-product-".concat(addon.productId, "-").concat(index),
        className: "product-addon-card ".concat(isSelected ? 'product-addon-card--selected' : '', " ").concat(!hasAvailableVariant ? 'product-addon-card--disabled' : ''),
        "data-product-id": addon.productId
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", {
        type: "checkbox",
        id: "addon-product-".concat(addon.productId),
        name: "addons",
        value: addon.productId,
        className: "product-addon-card__checkbox",
        checked: isSelected,
        disabled: !hasAvailableVariant,
        onChange: () => {
          if (hasAvailableVariant) {
            if (isSelected) {
              handleVariantSelect(addon.productId, null);
            }
          }
        },
        style: {
          display: 'none'
        }
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__label"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__content"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__image"
      }, addon.image ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("img", {
        src: addon.image,
        alt: addon.productTitle,
        width: "48",
        height: "48",
        loading: "lazy"
      }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__placeholder"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2",
        ry: "2"
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("circle", {
        cx: "8.5",
        cy: "8.5",
        r: "1.5"
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("polyline", {
        points: "21,15 16,10 5,21"
      })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__details"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("p", {
        className: "product-addon-card__product-title"
      }, addon.productTitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__variant-select"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(CustomDropdown, {
        key: "dropdown-".concat(addon.productId, "-").concat(resetKey),
        id: "variant-select-".concat(addon.productId),
        placeholder: "Select size to add",
        value: selectedAddonVariantId || '',
        disabled: !hasAvailableVariant,
        options: [{
          value: '',
          label: 'None'
        }, ...addon.variants.map(variant => ({
          value: variant.id,
          label: variant.title + (variant.available === false ? ' - Sold out' : ''),
          disabled: variant.available === false
        }))],
        onChange: variantId => {
          var parsedVariantId = variantId ? parseInt(variantId, 10) : null;
          handleVariantSelect(addon.productId, parsedVariantId);
          setSelectedAddons(prev => {
            var newSet = new Set(prev);
            if (parsedVariantId) {
              newSet.add(addon.productId);
            } else {
              newSet.delete(addon.productId);
            }
            return newSet;
          });
        }
      })), selectedVariant && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__price"
      }, selectedVariant.compareAtPrice && selectedVariant.compareAtPrice > selectedVariant.price ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "price price--on-sale"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "visually-hidden"
      }, "Sale price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "price-item price-item--sale price-item--last"
      }, formatPrice(selectedVariant.price)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "visually-hidden"
      }, "Regular price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("s", {
        className: "price-item price-item--regular"
      }, formatPrice(selectedVariant.compareAtPrice))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "price"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "visually-hidden"
      }, "Regular price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
        className: "price-item price-item--regular"
      }, formatPrice(selectedVariant.price))))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
        className: "product-addon-card__checkbox-icon ".concat(isSelected ? 'product-addon-card__checkbox-icon--selected' : ''),
        onClick: () => {
          if (hasAvailableVariant) {
            if (isSelected) {
              handleVariantSelect(addon.productId, null);
              setSelectedAddons(prev => {
                var newSet = new Set(prev);
                newSet.delete(addon.productId);
                return newSet;
              });
            }
          }
        },
        style: {
          cursor: hasAvailableVariant && isSelected ? 'pointer' : 'not-allowed'
        }
      }, isSelected && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
        className: "product-addon-card__checkbox-icon-checkmark",
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "11",
        viewBox: "0 0 15 11",
        fill: "none"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.3794 0.307426C14.5763 0.50433 14.6869 0.771353 14.6869 1.04978C14.6869 1.3282 14.5763 1.59522 14.3794 1.79213L5.97945 10.1921C5.78254 10.389 5.51552 10.4996 5.2371 10.4996C4.95868 10.4996 4.69165 10.389 4.49475 10.1921L0.294747 5.99213C0.103481 5.79409 -0.00235265 5.52886 3.96928e-05 5.25355C0.00243203 4.97825 0.112859 4.71489 0.307538 4.52022C0.502217 4.32554 0.765569 4.21511 1.04088 4.21272C1.31618 4.21033 1.58141 4.31616 1.77945 4.50743L5.2371 7.96508L12.8947 0.307426C13.0917 0.110581 13.3587 0 13.6371 0C13.9155 0 14.1825 0.110581 14.3794 0.307426Z",
        fill: "white"
      }))));
    })));
  }
  return null;
};

/***/ }),

/***/ "./js/components/product-design-mode.js":
/*!**********************************************!*\
  !*** ./js/components/product-design-mode.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   productDesignMode: () => (/* binding */ productDesignMode)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _design_components_upload_design_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./design-components/upload-design-selector */ "./js/components/design-components/upload-design-selector.js");




var productDesignMode = _ref => {
  var {
    shopifyData
  } = _ref;
  var data = shopifyData || {};
  var [isUploadContainerOpen, setIsUploadContainerOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  var [hasUploadedFiles, setHasUploadedFiles] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "product-design-mode"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "design-method-selector"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_design_components_upload_design_selector__WEBPACK_IMPORTED_MODULE_1__.UploadDesign, {
    shopifyData: shopifyData,
    isUploadContainerOpen: isUploadContainerOpen,
    setIsUploadContainerOpen: setIsUploadContainerOpen,
    onFilesChange: setHasUploadedFiles
  })));
};

/***/ }),

/***/ "./js/components/react-wrapper.js":
/*!****************************************!*\
  !*** ./js/components/react-wrapper.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-dom/client */ "./node_modules/react-dom/client.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_3__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  var appContainer = document.querySelectorAll(container);
  var singlePropsEl = document.querySelector(propsEl);
  var props = {};
  if (singlePropsEl) {
    props = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse(singlePropsEl === null || singlePropsEl === void 0 ? void 0 : singlePropsEl.innerHTML) || {};
  }
  return [...appContainer].map(appTarget => {
    var initialized = appTarget.dataset.initialized || false;
    if (appTarget && !initialized) {
      if (!singlePropsEl) {
        if (propsEl) {
          var _appTarget$querySelec;
          props = {};
          props = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse((_appTarget$querySelec = appTarget.querySelector(propsEl)) === null || _appTarget$querySelec === void 0 ? void 0 : _appTarget$querySelec.innerHTML) || {}; //get json from the script id 
        }
      }
      appTarget.dataset.initialized = true;
      var root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_2__.createRoot)(appTarget);

      // Store the root reference for potential re-renders
      appTarget._reactRoot = root;

      // Initial render
      root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Component, {
        shopifyData: props
      }));

      // Listen for cart form updates
      appTarget.addEventListener('cartFormUpdate', event => {
        var newProps = _objectSpread(_objectSpread({}, props), event.detail);
        root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Component, {
          shopifyData: newProps
        }));
      });
      return root;
    }
  });
});

/***/ }),

/***/ "./js/components/use-large-upload.js":
/*!*******************************************!*\
  !*** ./js/components/use-large-upload.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useLargeUpload: () => (/* binding */ useLargeUpload)
/* harmony export */ });
/* unused harmony exports getUploadLocations, clearUploadLocations, removeLocationByUrl, addLocationsToCartProperties */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _api_integrations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api-integrations */ "./js/components/api-integrations.js");
/* harmony import */ var _chunk_file__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./chunk-file */ "./js/components/chunk-file.js");




var MAX_PARALLEL_UPLOADS = _api_integrations__WEBPACK_IMPORTED_MODULE_2__.UPLOAD_CONFIG.CONCURRENCY;

// Storage for upload locations (persists across component renders)
// Using Set to store unique location URLs
var uploadLocationsSet = new Set();

// Store upload location
var storeUploadLocation = location => {
  if (location) {
    uploadLocationsSet.add(location);
  } else {
    console.warn('⚠️ Cannot store location - location is missing');
  }
};

// Remove upload location by location URL
var removeUploadLocation = location => {
  if (location) {
    var hadLocation = uploadLocationsSet.has(location);
    if (hadLocation) {
      uploadLocationsSet.delete(location);
    }
  }
};

// Get all stored upload locations (returns array of locations)
var getUploadLocations = () => {
  var locations = Array.from(uploadLocationsSet);
  return locations;
};

// Clear all stored upload locations
var clearUploadLocations = () => {
  uploadLocationsSet.clear();
};

// Remove location by location URL (exported for use in components)
var removeLocationByUrl = location => {
  removeUploadLocation(location);
};

// Add upload locations to cart properties (FormData)
var addLocationsToCartProperties = formData => {
  var locations = getUploadLocations();
  if (locations.length === 0) {
    return;
  }

  // If there's only one location, add it as a single property
  if (locations.length === 1) {
    formData.append('properties[Uploaded File]', locations[0]);
  } else {
    // If there are multiple locations, add them as indexed properties
    locations.forEach((location, index) => {
      formData.append("properties[Uploaded File ".concat(index + 1, "]"), location);
    });
  }
};

// Expose functions globally for use in vanilla JS files
if (typeof window !== 'undefined') {
  window.addLocationsToCartProperties = addLocationsToCartProperties;
  window.clearUploadLocations = clearUploadLocations;
  window.getUploadLocations = getUploadLocations;
  window.removeLocationByUrl = removeLocationByUrl;
}

// Throttle progress updates to avoid excessive re-renders
function throttleProgress(onProgress, totalBytes, partProgressMap) {
  var lastUpdateTime = 0;
  var THROTTLE_MS = 100; // Update at most every 100ms

  return () => {
    var now = Date.now();
    if (now - lastUpdateTime < THROTTLE_MS) {
      return;
    }
    lastUpdateTime = now;

    // Calculate total uploaded bytes from all parts
    var totalUploaded = 0;
    partProgressMap.forEach(bytes => {
      totalUploaded += bytes;
    });
    var percent = Math.min(100, totalUploaded / totalBytes * 100);
    onProgress({
      uploadedBytes: totalUploaded,
      totalBytes,
      percent
    });
  };
}
function uploadPart(_ref) {
  var {
    url,
    blob,
    partNumber,
    onProgress,
    partProgressMap,
    totalBytes,
    updateProgress,
    signal
  } = _ref;
  return new Promise((resolve, reject) => {
    var _attempt = function attempt() {
      var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", url);

      // Track this part's progress separately
      var partUploaded = 0;
      xhr.upload.onprogress = e => {
        if (e.lengthComputable && e.loaded !== partUploaded) {
          partUploaded = e.loaded;
          // Update this part's progress in the map
          partProgressMap.set(partNumber, partUploaded);
          // Trigger throttled progress update
          updateProgress();
        }
      };
      xhr.onload = () => {
        if (xhr.status === 200) {
          var _xhr$getResponseHeade;
          // Mark this part as fully uploaded
          partProgressMap.set(partNumber, blob.size);
          updateProgress();
          var etag = (_xhr$getResponseHeade = xhr.getResponseHeader("ETag")) === null || _xhr$getResponseHeade === void 0 ? void 0 : _xhr$getResponseHeade.replaceAll('"', "");
          resolve({
            PartNumber: partNumber,
            ETag: etag
          });
        } else if (retry < 1) {
          console.warn("Retrying part ".concat(partNumber, " after ").concat(xhr.status));
          _attempt(retry + 1);
        } else {
          reject(new Error("Failed to upload part ".concat(partNumber, ": ").concat(xhr.status)));
        }
      };
      xhr.onerror = () => reject(new Error("Network error on part ".concat(partNumber)));
      xhr.onabort = () => reject(new DOMException("Upload aborted", "AbortError"));
      xhr.send(blob);
      if (signal) {
        signal.addEventListener("abort", () => {
          try {
            xhr.abort();
          } catch (_) {}
        });
      }
    };
    _attempt();
  });
}
function useLargeUpload() {
  var uploadFile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/function () {
    var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (file) {
      var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
      var signal = arguments.length > 2 ? arguments[2] : undefined;
      var filename = file.name;
      var contentType = file.type || "application/octet-stream";

      // 1️⃣ Create multipart upload
      var {
        key,
        uploadId
      } = yield (0,_api_integrations__WEBPACK_IMPORTED_MODULE_2__.createUpload)(filename, contentType, signal);

      // 2️⃣ Split file into parts using chunkFile utility
      var fileParts = (0,_chunk_file__WEBPACK_IMPORTED_MODULE_3__.getFileParts)(file);
      var partNumbers = fileParts.map(part => part.partNumber);
      // Create a map for O(1) lookup of file parts by part number
      var filePartsMap = new Map(fileParts.map(part => [part.partNumber, part.blob]));
      var {
        urls
      } = yield (0,_api_integrations__WEBPACK_IMPORTED_MODULE_2__.signParts)(key, uploadId, partNumbers, contentType, signal);

      // 3️⃣ Track progress per-part to avoid race conditions
      var partProgressMap = new Map(); // partNumber -> uploaded bytes for that part
      var totalBytes = file.size;
      var partsData = [];

      // Initialize all parts to 0
      fileParts.forEach(part => {
        partProgressMap.set(part.partNumber, 0);
      });

      // Create throttled progress updater
      var updateProgress = throttleProgress(onProgress, totalBytes, partProgressMap);

      // 4️⃣ Parallel upload with concurrency control
      var currentIndex = 0;
      var activeUploads = 0;
      return yield new Promise((resolve, reject) => {
        var _startNext = /*#__PURE__*/function () {
          var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
            if (signal !== null && signal !== void 0 && signal.aborted) {
              reject(new DOMException("Upload aborted", "AbortError"));
              return;
            }
            if (currentIndex >= urls.length && activeUploads === 0) {
              // All parts done - sort partsData by PartNumber before completing
              partsData.sort((a, b) => a.PartNumber - b.PartNumber);
              (0,_api_integrations__WEBPACK_IMPORTED_MODULE_2__.completeUpload)(key, uploadId, partsData, signal).then(res => {
                onProgress({
                  uploadedBytes: totalBytes,
                  totalBytes,
                  percent: 100
                });
                console.log('Upload complete - response:', res);

                // Store the location from the response
                if (res && res.location) {
                  storeUploadLocation(res.location);
                } else {
                  console.warn('Missing location in response:', res);
                }
                resolve(res);
              }).catch(error => {
                reject(error);
              });
              return;
            }
            while (activeUploads < MAX_PARALLEL_UPLOADS && currentIndex < urls.length) {
              var {
                partNumber,
                url
              } = urls[currentIndex++];
              // Use the blob from getFileParts map for efficient lookup
              var blob = filePartsMap.get(partNumber);
              activeUploads++;
              uploadPart({
                url,
                blob,
                partNumber,
                onProgress,
                partProgressMap,
                totalBytes,
                updateProgress,
                signal
              }).then(result => {
                partsData.push(result);
              }).catch(err => {
                if (err.name === "AbortError") {
                  reject(err);
                } else {
                  console.error("Part upload error:", err);
                  reject(err);
                }
              }).finally(() => {
                activeUploads--;
                _startNext();
              });
            }
          });
          return function startNext() {
            return _ref3.apply(this, arguments);
          };
        }();
        _startNext();
      });
    });
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  return {
    uploadFile
  };
}

/***/ }),

/***/ "./js/sections/custom-global.js":
/*!**************************************!*\
  !*** ./js/sections/custom-global.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _components_react_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/react-wrapper */ "./js/components/react-wrapper.js");
/* harmony import */ var _components_product_addons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/product-addons */ "./js/components/product-addons.js");
/* harmony import */ var _components_product_design_mode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/product-design-mode */ "./js/components/product-design-mode.js");



document.addEventListener('DOMContentLoaded', () => {
  (0,_components_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(_components_product_addons__WEBPACK_IMPORTED_MODULE_1__.productAddons, "product-addons", "#product-addons-data");
  (0,_components_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(_components_product_design_mode__WEBPACK_IMPORTED_MODULE_2__.productDesignMode, "design-mode", "#design-mode-data");
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"custom-global": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./js/sections/custom-global.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;